export default __webpack_public_path__ + "static/media/LOGO_CARBO_FRANCE.3def740a.png";